import SanitizedText from 'sanitize-text/components/SanitizedText';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Image } from 'foundations-components/transitional/components/Image';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Timestamp } from './Timestamp';
import I18n from 'I18n';
import { UserIcon } from 'foundations-assets/icons/components/UserIcon';
import { getInitials } from '../utils/getInitials';
import { useMessageAttachments } from '../hooks/useMessageAttachments';
import { MessageAttachment } from './MessageAttachment';
import { MessageImage } from './MessageImage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const ThreadMessage = ({
  message,
  responders,
  attachmentsMap,
  sensitiveAttachmentsMetadata
}) => {
  var _message$text, _message$richText;
  const isInitialMessage = message['@type'] === 'INITIAL_MESSAGE';
  const responderKey = JSON.stringify(message.sender);
  const threadResponder = responders[responderKey];
  const isHidden = Boolean(message.hiddenBy);
  const hasContent = message.richText || message.text;
  const noPlainText = ((_message$text = message.text) === null || _message$text === void 0 ? void 0 : _message$text.trim()) === '';
  const avatarUrl = threadResponder === null || threadResponder === void 0 ? void 0 : threadResponder.avatar;
  const avatarInitials = getInitials(threadResponder === null || threadResponder === void 0 ? void 0 : threadResponder.displayName);
  const [images, attachments] = useMessageAttachments([message], attachmentsMap, sensitiveAttachmentsMetadata);
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "row",
    gap: "600",
    alignItems: "start",
    children: [/*#__PURE__*/_jsx(Flex, {
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      blockSize: "fit-content",
      children: avatarUrl ? /*#__PURE__*/_jsx(Image, {
        src: avatarUrl,
        alt: (threadResponder === null || threadResponder === void 0 ? void 0 : threadResponder.displayName) || I18n.text('customer-portal-app.ticketThread.messageContent.avatarAltText'),
        shape: "circle",
        responsive: false,
        inlineSize: "40px",
        blockSize: "40px"
      }) : /*#__PURE__*/_jsx(Flex, {
        borderRadius: "full",
        backgroundColor: "fill-primary-default",
        inlineSize: "40px",
        blockSize: "40px",
        alignItems: "center",
        justifyContent: "center",
        children: avatarInitials ? /*#__PURE__*/_jsx(Text, {
          typography: "heading-25",
          color: "text-primary-default",
          children: avatarInitials
        }) : /*#__PURE__*/_jsx(UserIcon, {
          size: "500",
          color: "icon-primary-default"
        })
      })
    }), /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      gap: "200",
      flex: "1",
      minInlineSize: "0",
      children: [/*#__PURE__*/_jsxs(Flex, {
        flexDirection: "row",
        gap: "200",
        alignItems: "baseline",
        children: [/*#__PURE__*/_jsx(Text, {
          typography: "heading-100",
          children: isInitialMessage ? /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customer-portal-app.ticketThread.messageContent.welcomeMessageTypeHeader"
          }) : threadResponder ? threadResponder.displayName : /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customer-portal-app.ticketThread.messageContent.automatedMessageTypeHeader"
          })
        }), /*#__PURE__*/_jsx(Text, {
          typography: "detail-100",
          color: "text-core-default",
          "data-test-id": "thread-message-timestamp",
          children: /*#__PURE__*/_jsx(Timestamp, {
            timestamp: message.timestamp
          })
        })]
      }), /*#__PURE__*/_jsx(Flex, {
        flexDirection: "column",
        gap: "200",
        blockSize: "100%",
        minInlineSize: "0",
        children: isHidden || !hasContent ? /*#__PURE__*/_jsx(Text, {
          fontStyle: "italic",
          typography: "body-100",
          color: "text-core-subtle",
          children: isHidden ? /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customer-portal-app.ticketThread.messageContent.isHidden"
          }) : /*#__PURE__*/_jsx(FormattedMessage, {
            message: "customer-portal-app.ticketThread.messageContent.noContent"
          })
        }) : /*#__PURE__*/_jsxs(_Fragment, {
          children: [noPlainText ? null : /*#__PURE__*/_jsx(Text, {
            as: "div",
            typography: "body-100",
            color: "text-core-default",
            children: /*#__PURE__*/_jsx(SanitizedText, {
              body: ((_message$richText = message.richText) === null || _message$richText === void 0 ? void 0 : _message$richText.replace(/(background-)?color\s*:[^;"']+/gi, '')) || message.text || I18n.text('customer-portal-app.ticketThread.messageContent.noContent'),
              formattingOptions: {
                shouldPreventAutoLinker: true
              }
            })
          }), images.length > 0 && /*#__PURE__*/_jsx(Flex, {
            flexDirection: "column",
            gap: "200",
            alignItems: "start",
            maxInlineSize: "100%",
            children: images.map(image => /*#__PURE__*/_jsx(MessageImage, {
              image: image
            }, image.fileId))
          }), attachments.length > 0 && /*#__PURE__*/_jsx(Flex, {
            flexDirection: "row",
            gap: "200",
            flexWrap: "wrap",
            children: attachments.map(attachment => /*#__PURE__*/_jsx(MessageAttachment, {
              attachment: attachment.attachment,
              sensitiveAttachment: attachment.sensitiveAttachment,
              inThread: true
            }, attachment.fileId))
          })]
        })
      })]
    })]
  });
};